// import React, { useState, useEffect, useRef } from 'react'
import React, { useRef, useEffect, useState } from 'react'
import './styles.scss'

export default function SmallRoadmapBlock({
  anchor,
  startyear,
  endyear,
  progress,
  icon,
}) {
  const ref = useRef()
  const [scrolledIn, setScrolledIn] = useState(false)

  useEffect(() => {
    if (ref.current) {
      window.addEventListener('scroll', () => {
        ref.current.getBoundingClientRect().top - window.innerHeight <= 0
          ? setScrolledIn(true)
          : setScrolledIn(false)
      })
    }
  }, [ref])

  return (
    <div className={'dhsv-small-roadmap'} ref={ref}>
      <style>
        {`
          @keyframes barexpand {
            0% {
              width: 0;
            }
            100% {
              width: ${progress}%;
            }
          }
        `}
      </style>
      <div className="start">{startyear}</div>
      <div className="progressbar">
        <div className={`progress ${scrolledIn ? 'animated' : ''}`}>
          <a href={`#${anchor}`}>
            {icon == 'feet' ? (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84.8 56.8">
                <g className={`foot-bottom ${scrolledIn ? 'animation' : ''}`}>
                  <path
                    className="svg-small-roadmap-feet"
                    d="M65.3,51.6c0.5,0.6,1.3,0.7,1.9,0.3c0.4-0.7,0.2-1.7-0.6-2.1c-0.4-0.3-1-0.2-1.5,0
	                C64.6,50.4,64.8,51.2,65.3,51.6"
                  />
                  <path
                    className="svg-small-roadmap-feet"
                    d="M68.4,49.2c0.7,0.6,1.6,0.5,2.2-0.1c0.3-0.8,0-1.7-0.7-2.2c-0.7-0.6-1.6-0.5-2.2,0.1
	                C67.2,47.9,67.6,48.8,68.4,49.2"
                  />
                  <path
                    className="svg-small-roadmap-feet"
                    d="M71.7,46.2c1.1,0.4,2.3-0.2,2.7-1.4c0-1.2-0.8-2.2-2.1-2.3c-1.1-0.4-2.3,0.2-2.7,1.4
	                C69.6,45.1,70.5,46,71.7,46.2"
                  />
                  <path
                    className="svg-small-roadmap-feet"
                    d="M74.2,41.8c1.6,0.3,3.2-0.5,3.4-1.7c0.3-1.2-0.9-2.4-2.6-2.7s-3.2,0.5-3.4,1.7
	                C71.4,40.2,72.5,41.4,74.2,41.8"
                  />
                  <path
                    className="svg-small-roadmap-feet"
                    d="M74.8,36.1c2.7,0.6,5-0.4,5.4-2.3c0.4-1.9-1.3-3.9-3.9-4.5c-2.7-0.6-5,0.4-5.4,2.3
	                C70.5,33.5,72.2,35.5,74.8,36.1"
                  />
                  <path
                    className="svg-small-roadmap-feet"
                    d="M68.4,30.9c-1-1.2-4.5-4.8-16.6,5.2c-0.8,0.5-1.6,0.9-2.5,1.1c-1.4,0.1-2.8-0.2-4-0.9
	                c-3.1-1.7-8.9-3.3-12.1-0.6c-1.8,1.5-2.3,4.9-1.3,7.2c1.6,3.7,6.8,5.8,12.4,3.8c2.7-0.9,5.6-0.4,7.7,1.3c4.5,2.7,11,3.6,13.9-0.3
	                C68.8,43.5,73.3,36.3,68.4,30.9"
                  />
                </g>
                <g className={`foot-top ${scrolledIn ? 'animation' : ''}`}>
                  <path
                    className="svg-small-roadmap-feet"
                    d="M36,3.3c0.4-0.7,1.1-0.9,1.8-0.7c0.5,0.5,0.5,1.3,0.1,1.8c-0.4,0.7-1.1,0.9-1.8,0.7
	                C35.6,4.7,35.4,3.9,36,3.3"
                  />
                  <path
                    className="svg-small-roadmap-feet"
                    d="M39.5,5.2c0.6-0.7,1.5-0.8,2.3-0.3c0.5,0.8,0.4,1.7-0.4,2.2c-0.6,0.7-1.5,0.8-2.3,0.3
	                C38.6,6.8,38.7,5.8,39.5,5.2"
                  />
                  <path
                    className="svg-small-roadmap-feet"
                    d="M43.2,7.6c1.1-0.6,2.3-0.1,3,0.8c0.3,1.2-0.5,2.3-1.6,2.6c-1.1,0.6-2.3,0.1-3-0.8
	              C41.4,9.1,42,7.9,43.2,7.6"
                  />
                  <path
                    className="svg-small-roadmap-feet"
                    d="M46.6,11.5c1.6-0.6,3.2-0.2,3.6,1.1c0.4,1.1-0.5,2.5-2,3.1c-1.6,0.6-3.2,0.2-3.6-1.1
	                C44.2,13.4,45,12.1,46.6,11.5"
                  />
                  <path
                    className="svg-small-roadmap-feet"
                    d="M48.2,16.9c2.5-1.1,5-0.5,5.7,1.3s-0.6,4-3.1,5.1c-2.5,1.1-5,0.5-5.7-1.3
	                C44.5,20.3,45.8,18,48.2,16.9"
                  />
                  <path
                    className="svg-small-roadmap-feet"
                    d="M42.9,23.2c-0.8,1.3-3.6,5.6-17.3-2c-0.8-0.4-1.7-0.6-2.6-0.5c-1.4,0.1-2.6,0.7-3.8,1.6
	                c-2.7,2.3-8.1,4.9-11.7,2.8c-2-1.1-3.2-4.4-2.6-6.9c0.7-3.8,5.5-6.9,11.3-5.9c1.2,0.2,2.4,0.1,3.6-0.3c1.4-0.5,2.7-1.3,3.7-2.5
	                C27.4,6,33.6,4,37.2,7.3S46.7,17.1,42.9,23.2"
                  />
                </g>
              </svg>
            ) : icon == 'speech' ? (
              <svg
                className="svg-warning-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 101.1"
              >
                <path
                  className="svg-warning-circle"
                  d="M50,100c-9.8,0-19-2.8-26.7-7.7L1.3,101.1l7.3-23.1C3.2,70,0,60.4,0,50,0,22.4,22.4,0,50,0s50,22.4,50,50-22.4,50-50,50Z"
                />
                <g>
                  <path
                    className="svg-warning-mark"
                    d="M11.09,38.01h4.52c.99,0,1.65,.36,2.18,1.16l7.33,11.16c1.12,1.72,1.85,3.1,3.07,6.04-.63-3.17-.79-4.59-.79-6.54v-11.82h4.98v23.57h-4.52c-.99,0-1.65-.36-2.18-1.16l-7.33-11.16c-1.16-1.75-1.78-3-3.07-6.04,.63,3.37,.79,4.72,.79,6.5v11.85h-4.98v-23.57Z"
                  />
                  <path
                    className="svg-warning-mark"
                    d="M37.46,38.08h15.08v4.62h-9.7v4.55h9.44v4.65h-9.44v5.02h9.9v4.65h-15.28v-23.5Z"
                  />
                  <path
                    className="svg-warning-mark"
                    d="M61.22,38.01c1.19,5.78,1.42,6.83,2.94,13.2,.69,2.87,.92,4.03,1.02,4.98l.1,2.41,.26-2.47c.07-.83,.56-3.04,1.16-5.15,.43-1.52,.69-2.48,.76-2.77l1.35-5.31,1.16-4.88h6.44l.59,2.84,1.65,7.29,1.29,5.38c.43,1.78,.56,2.77,.69,5.08,.17-2.47,.36-3.7,.73-5.15l1.42-5.28,1.91-7.72,.56-2.44h5.58c-2.18,8.71-3.76,14.19-6.73,23.57h-7.16l-1.55-6.21c-1.91-7.72-2.15-9.17-2.31-13.56-.4,5.41-.59,6.4-2.64,13.7l-1.68,6.07h-7.16l-1.06-3.6c-1.12-3.83-2.61-9.5-3.6-13.63l-1.49-6.34h5.78Z"
                  />
                </g>
              </svg>
            ) : (
              <svg
                className="svg-warning-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 101.1"
              >
                <path
                  className="svg-warning-circle"
                  d="M50,100c-9.8,0-19-2.8-26.7-7.7L1.3,101.1l7.3-23.1C3.2,70,0,60.4,0,50,0,22.4,22.4,0,50,0s50,22.4,50,50-22.4,50-50,50Z"
                />
                <g>
                  <path
                    className="svg-warning-mark"
                    d="M13.3,37.31h4.9c1.07,0,1.79,.39,2.36,1.25l7.94,12.09c1.22,1.86,2,3.36,3.33,6.55-.68-3.44-.86-4.97-.86-7.08v-12.81h5.4v25.55h-4.9c-1.07,0-1.79-.39-2.36-1.25l-7.94-12.09c-1.25-1.9-1.93-3.26-3.33-6.55,.68,3.65,.86,5.12,.86,7.05v12.85h-5.4v-25.55Z"
                  />
                  <path
                    className="svg-warning-mark"
                    d="M42.89,37.38h16.35v5.01h-10.52v4.94h10.23v5.04h-10.23v5.44h10.73v5.04h-16.57v-25.48Z"
                  />
                  <path
                    className="svg-warning-mark"
                    d="M70.95,37.31v14.38c0,2.61,.21,3.83,.86,4.69,.86,1.22,2.29,1.86,4.11,1.86s3.33-.68,4.11-1.82c.61-.89,.82-2.15,.82-4.72v-14.38h5.94v14.88c0,3.61-.5,5.73-1.75,7.44-1.75,2.4-4.87,3.65-9.12,3.65-3.94,0-6.87-1.04-8.7-3.11-1.57-1.75-2.18-4.01-2.18-7.98v-14.88h5.9Z"
                  />
                </g>
              </svg>
            )}
          </a>
        </div>
      </div>
      <div className="end">
        {endyear}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.9 41.8">
          <rect
            x="2"
            y="2.4"
            className="svg-gray-flag"
            width="3.7"
            height="38.1"
          />
          <path
            className="svg-gray-flag"
            d="M39.4,2.5H7.7v25.2h31.6l-8.6-12.6L39.4,2.5z"
          />
        </svg>
      </div>
    </div>
  )
}
